import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=082c7fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082c7fac"]])

export default __exports__